import { QuestionProps } from 'src/types/questionnaire.types';
import Calendar from 'src/app/components/kit/calendar/Calendar';

export const DateSelectionQuestion = ({
  question,
  handleSelectAnswer,
  stepNumber,
  selectedOption = undefined,
  maxDate,
  minDate,
}: QuestionProps) => {
  const onSelect = (answer: Date) => {
    handleSelectAnswer({ ...question, date: answer }, stepNumber);
  };

  return (
    <Calendar
      className='pb-2 w-full'
      selectedDate={selectedOption as Date}
      onDateSelect={onSelect}
      maxDate={maxDate}
      minDate={minDate}
    />
  );
};
